module.exports = __webpack_public_path__ + "static/media/decoration-gray-top1.2b06e87a.svg";